import { cn } from '../shared/lib/utils'
import { SearchIcon } from 'lucide-react'

/** ⌘ on Apple hardware, Ctrl everywhere else. Read once — it can't change. */
const shortcutLabel =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent) ? '⌘K' : 'Ctrl K'

interface SearchTriggerProps {
  onClick: () => void
  /** Show the keyboard-shortcut chip (desktop only — no modifier keys on a phone) */
  showShortcut?: boolean
  className?: string
}

/**
 * Opens the SearchPalette. Sits above the nav links on both surfaces (desktop
 * sidebar, mobile drawer) — bordered rather than pill-filled so it reads as a
 * field, not as a sixth navigation destination.
 */
export function SearchTrigger({ onClick, showShortcut, className }: SearchTriggerProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Search jobs and clients"
      aria-keyshortcuts={showShortcut ? 'Meta+K Control+K' : undefined}
      className={cn(
        'flex w-full cursor-pointer items-center gap-3 rounded-full border border-border px-4 text-sm text-muted-foreground transition-colors hover:bg-[color-mix(in_srgb,currentColor_7%,transparent)] hover:text-foreground',
        className
      )}
    >
      <SearchIcon className="h-4 w-4 shrink-0" />
      <span className="flex-1 text-left">Search</span>
      {showShortcut && (
        <kbd className="shrink-0 rounded-md border border-border px-1.5 py-0.5 font-sans text-[11px] leading-none">
          {shortcutLabel}
        </kbd>
      )}
    </button>
  )
}
